import React from 'react';
import PropTypes from 'prop-types';

const AlertMsg = props => {
  const { type, msg } = props;
  const classes = `alert alert-${type} mb-1`;
  return (
    <div className={classes} role="alert">
      {msg}
    </div>
  );
};

AlertMsg.propTypes = {
  type: PropTypes.string,
  msg: PropTypes.string
};

export default AlertMsg;
